"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const standards = [{
  title: "Executive-Grade Quality Assurance",
  description: "We don't just clean; we curate environments. Every service concludes with a rigorous 50-point inspection covering high-touch surfaces, hidden corners, and air quality checks to ensure a 5-star hotel standard of hygiene."
}, {
  title: "Professionally Vetted Cleaning Specialists\n\n",
  description: "Trust is our currency. Every member of our team undergoes strict background checks, police clearance, and specialized training in corporate etiquette and security protocols, ensuring your sensitive business data remains secure."
}, {
  title: "Premium Eco-Safe Cleaning Systems\n\n",
  description: "Sustainability meets sophistication. We utilize premium, hospital-grade eco-friendly products that are ruthlessly effective against pathogens while being safe for your staff, clients, and the environment."
}, {
  title: "The Gold Guarantee",
  description: "We stand behind our work with an ironclad promise. If any aspect of our service does not meet the Gold Standard, we return immediately to rectify it at no cost to you. Your satisfaction is non-negotiable."
}];
export default function TheGoldStandardDifference() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}